Promise.all([
  import(/* webpackMode: "eager" */ './accordion.scss'),
  import('../../plugins/semantic/accordion.css'),
  import('../../plugins/semantic/accordion'),
]).then(() => {
  $('.widget.accordion').each(function (i, el) {
    $(el).data('widget', new Accordion(el))
    $(el).data('widget').init()
  })
})

function Accordion(el) {
  const self = this
  self.el = $(el)

  $(document).ready(function() {
    // Check if the current path contains "pets"
    if (window.location.hash === "#pets") {
        // Add the 'active' class to all children of '.dog-guidelines-&-conditions'
        $(".dog-guidelines-\\&-conditions").children().addClass("active");
  
        // Remove the 'hidden' class from all children of '.dog-guidelines-\\&-conditions .content'
        $(".dog-guidelines-\\&-conditions .content").children().removeClass("hidden");
    }
  });

  self.init = function () {
    if (process.env.NODE_ENV === 'development') {
      console.log('Accordion init', self)
    }
    // Check to stop double handling if this is called twice
    if (self.el.attr('data-accordion-init') === undefined) {
      // If this accordion contains other accordions, exit because otherwise we double up on click handlers
      self.el.css('opacity', 1)
      if (self.el.find('.ui.accordion').length >= 2) {
        return
      }
      self.el.children('.ui.accordion').accordion()
      self.el.attr('data-accordion-init', 'true')

    if (window.location.hash != null || "")
    {
      var accordionId = window.location.hash;
    }
    if (accordionId != null && $('.ui.accordion').children().find(accordionId) != null) {
      // Add the 'active' class to all children of '.dog-guidelines-&-conditions'
      $(accordionId).children().addClass("active");
      
      // Remove the 'hidden' class from all children of '.dog-guidelines-\\&-conditions .content'
      $(accordionId).children().removeClass("hidden");
      
      //Scrolling to the element id while considering the height of the header
      var headerHeight = $('.header-fixed').height() + 'px';
      $(accordionId).scrollHeight + headerHeight;


    }

    }
  }
}
